import Vue from 'vue'
import Vuex from 'vuex'
import api from "../api"
import API from '../api/fileAxios/token';
import smbSales from "./smbSales";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: null, // 登录用户信息
    menuwidth: 300,
    headerheight: 100,
    isCollapse: false,
    userLoginToken: '', // 用户登录token
  },
  mutations: {
    logout (state, vm) {
      state.user = null;
    },
    setUser (state, data) {
      state.user = data;
    },
    // 设置当前登录用户token
    setToken (state, data) {
      state.userLoginToken = data
    }
  },
  actions: {
    getuser ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.user != null && state.user !== '') {
          resolve(state.user);
        } else {
          api.curruser({}).then((res) => {
            let json = res.data;
            if (json.status === "200") {
              commit('setUser', json.data);
              sessionStorage.setItem('loginUserInformation', JSON.stringify(json.data))
              resolve(state.user);
            } else {
              reject();
            }
          }).catch(() => {
            reject();
          })
        }
      });
    },
    // 设置用户登录token信息
    async getUserToken (context, payload) {
      // if (context.state.userLoginToken != null) {
      //   return context.state.userLoginToken;
      // }
      try {
        const { data, status } = await API.postGenerate(payload);
        if (Number(status) === 200) {
          if (data.data.token) {
            // localStorage.setItem('user', JSON.stringify(data.data));
            localStorage.setItem('loginUserToken', data.data.token);
            context.commit('setToken', data.data.token);
            // 过期时间
            localStorage.setItem('adminLoginTokenExpiresDate', data.data.expiresDate);
          }
        }
      } catch (err) {
        console.error('获取用户异常', err);
      }
    },
    toggleMenu ({ commit, state }) {
      if (state.isCollapse) {
        //关闭状态 进行打开
        state.menuwidth = 200;
        state.isCollapse = false
      } else {
        state.menuwidth = 64;
        state.isCollapse = true
      }
    }
  },

  modules: {
    smbSales
  },
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js